import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

// Firebase web config is public-facing by design (these values end up in
// the client bundle either way). Security comes from Firestore + Storage
// rules and Auth checks, not from hiding the config. See
// https://firebase.google.com/docs/projects/api-keys for Firebase's own
// note on this. Hardcoded so cloud builds (Codemagic) don't need
// REACT_APP_FIREBASE_* env vars wired separately.
const firebaseConfig = {
  apiKey: "AIzaSyB0cPle8_xT-lzwzjviAYYW7Q-hh7WOAx0",
  authDomain: "service-pro-ff3ff.firebaseapp.com",
  projectId: "service-pro-ff3ff",
  storageBucket: "service-pro-ff3ff.firebasestorage.app",
  messagingSenderId: "1031044872391",
  appId: "1:1031044872391:web:93e84187c793d640e726e2",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// FCM web messaging — only initialize in browsers that support it
// (service workers + push API). isSupported() resolves false in older
// browsers / in-app webviews; callers should treat that as "push unavailable
// on this device" rather than an error.
export const getMessagingInstance = async () => {
  if (typeof window === "undefined") return null;
  try {
    const supported = await isSupported();
    if (!supported) return null;
    return getMessaging(app);
  } catch {
    return null;
  }
};
